// SEO NoIndexMeta — выставляет robots=noindex для приватных страниц (внутри приложения).
// Не трогает title/og/canonical — только robots, чтобы поисковики не индексировали URL.
import { useEffect } from "react";

export function NoIndexMeta() {
	useEffect(() => {
		const previous = readRobots();
		writeRobots("noindex, nofollow, noarchive, nosnippet, noimageindex");
		return () => {
			if (previous !== null) writeRobots(previous);
		};
	}, []);
	return null;
}

function readRobots(): string | null {
	const el = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
	return el?.content ?? null;
}

function writeRobots(value: string) {
	let el = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
	if (!el) {
		el = document.createElement("meta");
		el.setAttribute("name", "robots");
		document.head.appendChild(el);
	}
	el.content = value;
}
